import { createVanIconComponent } from "./van"

const NotesOutlined = createVanIconComponent("notes-o")
export default NotesOutlined
